import { createContext } from "react"

export const CanvasControlsContext = createContext({
	parentX: 0,
	parentY: 0,
	parentWidth: 1,
	parentHeight: 1,
})
